import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormField } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {
    FormRowComponent,
    InstructionsComponent,
    InstructionsWithFieldsContainerComponent,
} from '@r1-compass-library/components';
import { DataMartConstants } from '@r1-compass-library/constants';

import { SaveGuardStore } from '@r1-compass-library/guards/save-guard.store';

import { DivisionCriteriaSourceSettingsFormService } from './division-criteria-source-settings-form.service';
import { SaveDivisionSettingsFooterComponent } from '../save-footer.component';
import { FormUnsavedChangesWarningDivisionSettings } from '@r1-compass-library/guards/hasUnsavedChanges.guard';

@Component({
    selector: 'r1-compass-app-division-data-mapping',
    templateUrl: './division-criteria-source-settings.component.html',
    imports: [
        InstructionsWithFieldsContainerComponent,
        InstructionsComponent,
        MatFormField,
        MatInputModule,
        ReactiveFormsModule,
        MatSelectModule,
        FormRowComponent,
        MatButtonModule,
        MatExpansionModule,
        SaveDivisionSettingsFooterComponent,
    ],
    providers: [DivisionCriteriaSourceSettingsFormService],
})
export class DivisionCriteriaSourceSettingsComponent implements FormUnsavedChangesWarningDivisionSettings {
    protected readonly divisionCriteriaSourceSettingsFormService = inject(DivisionCriteriaSourceSettingsFormService);
    readonly #formSaveWarningStore = inject(SaveGuardStore);

    protected readonly DataMartConstants = DataMartConstants;

    protected criteriaSourceSettingsForm = this.divisionCriteriaSourceSettingsFormService.criteriaSourceSettingsForm;

    canDeactivate$ = this.#formSaveWarningStore.deriveCanDeactivate$(this.criteriaSourceSettingsForm);
    saveGuardHandlerFn = this.#formSaveWarningStore.formUnsavedChangesWarningDivisionSettings;

    public onSave() {
        return this.divisionCriteriaSourceSettingsFormService.saveDivisionCriteriaSourceSettings();
    }

    constructor() {
        this.saveGuardHandlerFn({
            form: this.criteriaSourceSettingsForm,
            canDeactivate$: this.canDeactivate$,
        });
    }
}
